// custom functions

// smart debounced resize
(function($,sr){

    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    var debounce = function (func, threshold, execAsap) {
        var timeout;

        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            }

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 250);
        };
    };
    // smartresize
    jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');

var FE = {
	location: window.location,

    Lightbox: {
      init: function () {
          $('.lightbox').magnificPopup({
              type:'image',
              gallery:{enabled:true}
          });
      }
    },

    HeaderShrink: {
        init: function () {
            window.addEventListener('scroll', function(e){
                var distanceY = window.pageYOffset || document.documentElement.scrollTop,
                    shrinkOn = 100;
                if (distanceY < shrinkOn) {
                    //console.log('undo shrink');
                    if ( $('.page-header').hasClass('header-shrink') ) {
                        $('.page-header').removeClass('header-shrink');
                    }
                } else {
                    //console.log('shrink');
                    $('.page-header').addClass('header-shrink');
                }
            })
        }
    },

	MobileMenu: {
		init: function() {
            //FE.MobileMenu.indicateSubMenu();
			$('.burger-icon').on('click', function() {
			    $(this).toggleClass('active');
                $('.nav-main ul').slideToggle();
            });
		},
        indicateSubMenu: function() {
            $('.nav-mobile > ul > li').each(function() {
                if ( $(this).find('ul').length ) {
                    $(this).prepend('<span>&gt;</span>');
                }
                $(this).find('span').click(function() {
                    $(this).siblings('ul').slideToggle();
                });
            });
        }
	},

    HeroSlider: {
        init: function() {

        }
    },

    DayNightSwitch: {
        openingHour: 8,
        closingHour: 18,

        init: function () {
            var date = new Date();
            var h = date.getHours();

            //console.log(h);

            if ( h < FE.DayNightSwitch.openingHour || h > FE.DayNightSwitch.closingHour ) {
                $('.ce-hero-image').addClass('no-opening-hours');
            } else {
                $('.ce-hero-image').addClass('opening-hours');
            }

        }

    },

    ProjectSlider: {
	    init: function () {
            $('.project-slider-container').slick({
                dots: true,
                centerMode: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                slide: 'figure',
                autoplay: true,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 1281,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 601,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    },

    ContactMenu: {
	    sliderTimer: null,
        sliderIcons: $('.contact-menu-btn'),

	    init: function () {
            var contactBtn = $('.contact-menu-btn');
            FE.ContactMenu.sliderIcons.find('img').first().addClass('active');
            contactBtn.on('click', function () {
                //console.log('click');
                $('.contact-menu').toggleClass('active');
            });
            FE.ContactMenu.startIconSlider();
        },
        startIconSlider: function() {
	        //console.log( FE.ContactMenu.sliderIcons  );
            FE.ContactMenu.sliderTimer = setInterval(FE.ContactMenu.slideIcon, 4000);
        },
        slideIcon: function () {
	        var next = FE.ContactMenu.sliderIcons.find('.active').next();
	        //console.log( next );
	        if (next.length == 0 ) {
                next = FE.ContactMenu.sliderIcons.find('img').first();
            }
            FE.ContactMenu.sliderIcons.find('.active').removeClass('active');
            next.addClass('active');
        }
    },

    GridImageFadeIn: {

	    affectedImages: $('.ce-image-grid img'),

	    init: function () {
            FE.GridImageFadeIn.imageFadeIn();
            window.addEventListener('scroll', function(e) {
                FE.GridImageFadeIn.imageFadeIn();
            });
        },
        imageFadeIn: function () {
            FE.GridImageFadeIn.affectedImages.each(function () {
               if ( FE.Helper.isElementInViewport(this) ) {
                   $(this).addClass('visible');
               } else {
                   $(this).removeClass('visible');
               }
            });
        }
    },


    Helper: {
	    isElementInViewport: function(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },

        throttle: function (callback, limit) {
            var tick = false;
            return function () {
                if (!tick) {
                    callback.call();
                    tick = true;
                    setTimeout(function () {
                        tick = false;
                    }, limit);
                }
            }
        }
    }
};


// init custom functions
(function ($, window, document, undefined) {

	$(function () {

        FE.Lightbox.init();
		FE.MobileMenu.init();
		FE.HeaderShrink.init();
		FE.ContactMenu.init();

        if ( $('.project-slider-container').length ) {
            FE.ProjectSlider.init();
        }
        if ( $('.page-id-1').length ) {
            FE.DayNightSwitch.init();
        }
        if ( $('.ce-image-grid').length ) {
            FE.GridImageFadeIn.init();
        }
	});

}(jQuery, window, document));
